import { useTranslation } from 'react-i18next'

const RacistTeacherEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="racist-teacher-end-title"
      {...props}
    >
      <title id="racist-teacher-end-title">{t('antagonists:racistteacher:components:end')}</title>
      <defs>
        <clipPath id="racist-teacher-a">
          <path
            d="M1463.56 356.82c-9.01 5.77 2.88 30.99 5.77 56.94s12.97 57.3 0 71.71c-12.97 14.41-16.08 27.15-14.27 39.05 1.8 11.89 3.46 19.33 6.71 22.58l6.13 6.13-4.68 15.86s21.98 14.78 52.97 9.73 52.61-11.89 69.91-10.81c17.3 1.08 25.59 3.6 25.23 2.52s.36-14.05.36-14.05 8.29 3.24 10.45-7.93-10.09-56.94-3.6-80c6.49-23.06 45.57-111.42 32.96-124.76-12.61-13.33-31.52-19.39-40.89-23.71-9.37-4.32-32.07-17.66-32.07-17.66s-7.21 28.47-21.98 40.36c-14.78 11.89-32.07 37.84-32.07 37.84s-14.41-16.58-19.1-30.99c-4.68-14.41-4.68-23.06-4.68-23.06s-3.6 7.93-12.61 13.69c-9.01 5.77-24.51 16.58-24.51 16.58Z"
            style={{
              fill: '#2e425b',
            }}
          />
        </clipPath>
      </defs>
      <path
        d="M1611.71 922.82s1.43 12.44-2.6 23.75c-4.04 11.32-3.12 23.97-3.12 23.97s33.79-.5 34.09-1.23 3.97-12.55 2.78-17.41c-1.18-4.87-3.75-9.35-4.4-14.68s.92-24.87.92-24.87l-27.66 10.48Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <path
        d="M1622.18 943.17c-10-.29-15.75 13.3-16.51 13.25s-.74 11.03-5.09 19.56c-4.35 8.52-8.27 21.86-8.81 26.11-.54 4.25-.24 11.07-.24 11.07s26.63 8.59 38.93 5.39c12.31-3.2 16.1-7.23 16.1-7.23s1.02-7.74.83-19.84c-.19-12.1.11-20.39.42-24.91s-5.26-17.06-5.68-17.03 2.42 9.25-2.08 8.7-4.56-14.66-17.88-15.06Z"
        style={{
          fill: '#f5f2ed',
        }}
      />
      <path
        d="M1493.24 908.39s-2.01 11.06 0 21.11c2.01 10.05 5.28 21.61 5.28 21.61l-43.23 18.35-6.03-19.35s13.57-9.05 13.82-20.86c.25-11.81 1.01-28.15 1.01-28.15l29.15 7.29Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <path
        d="M1497.74 936.79h-2.96s2.34 9.82-2.55 11.17-19.63-4.79-19.63-4.79 2.71-5.2-.33-8.23c-3.04-3.04-11.47-5.74-11.47-5.74s-12.48 10.8-19.57 22.1-7.09 15.69-12.82 18.22-18.22 7.76-20.41 11.81c-2.19 4.05-1.46 17.15-1.46 17.15s18.33 1.58 36.71-2.14c18.39-3.71 22.94-6.92 31.88-8.77 8.94-1.86 13.16-1.18 21.09-3.37 7.93-2.19 13.33-4.72 13.33-4.72s0-14.17-2.53-21.26c-2.39-6.7-3.37-11.81-4.89-15.18s-4.22-6.24-4.39-6.24Z"
        style={{
          fill: '#f5f2ed',
        }}
      />
      <path
        d="M1547.7 298.22c-29.37 0-49.21 14.75-58.22 24.12s-2.51 41.69-2.51 41.69l55.86 37.12 64.87-81.08s-6.07-4.14-7.87-9.9c-1.8-5.77-3.44-8.56-14.62-10.72-11.17-2.16-36.79-1.22-37.51-1.22Zm-77.95 232.38s-2.18 20.21-7.1 35.5-7.1 42.06-9.29 60.63c-2.18 18.57-18.5 76.25-16.86 121.59 1.64 45.34 13.7 138.1 15.34 151.21 1.64 13.11 2.18 22.94 2.18 22.94s7.65 7.1 18.57 6.55c10.92-.55 24.03-.55 24.03-.55l2.73-15.84s7.65-.55 8.19-17.48c.55-16.93-9.54-115.83-8.99-130.03.55-14.2 53.12-137.3 51.48-137.3s-12.56-99.41-12.56-99.41l-67.73 2.18Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1494.61 537.18c.44 1.67 54.77 162.44 59.99 182.5 5.22 20.06 18.21 46.66 18.14 55.96s13.63 123 17.91 132.59c4.28 9.59 12.82 12.91 12.82 12.91l1.63 16.53s13.12.33 23.58-.6c10.46-.94 19.48-4.71 19.48-4.71l-2.28-14.93s5.45-7.85 4.22-13.95-25.1-139.65-25.42-159.37c-.32-19.73-1.98-100.86-1.35-126.55.63-25.69-15.8-66.21-19.9-78.53-4.1-12.32-29.56-32.64-29.56-32.64l-79.26 30.8Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1496.71 268.17s10.94 30.04 12.97 41.08c2.31 12.51-2.16 27.75-2.16 27.75s11.17 21.62 12.61 21.26 68.83-36.04 68.83-36.04l-14.05-8.65s-7.57-.72-9.73-11.53c-2.16-10.81-6.85-40-6.85-40l-61.62 6.13Z"
        style={{
          fill: '#e3b67d',
        }}
      />
      <path
        d="M1529.86 338.8c11.81-1.75 29.19-14.05 33.87-19.46 4.68-5.41 5.16-9.67 5.16-9.67l14.62 3.17-45.72 94.79-66.31-32.07 1.8-22.34 36.36-27.63s.76 16.1 20.22 13.21Z"
        style={{
          fill: '#f3faf9',
        }}
      />
      <path
        d="M1463.56 356.82c-9.01 5.77 2.88 30.99 5.77 56.94s12.97 57.3 0 71.71c-12.97 14.41-16.08 27.15-14.27 39.05 1.8 11.89 3.46 19.33 6.71 22.58l6.13 6.13-4.68 15.86s21.98 14.78 52.97 9.73 52.61-11.89 69.91-10.81c17.3 1.08 25.59 3.6 25.23 2.52s.36-14.05.36-14.05 8.29 3.24 10.45-7.93-10.09-56.94-3.6-80c6.49-23.06 45.57-111.42 32.96-124.76-12.61-13.33-31.52-19.39-40.89-23.71-9.37-4.32-32.07-17.66-32.07-17.66s-7.21 28.47-21.98 40.36c-14.78 11.89-32.07 37.84-32.07 37.84s-14.41-16.58-19.1-30.99c-4.68-14.41-4.68-23.06-4.68-23.06s-3.6 7.93-12.61 13.69c-9.01 5.77-24.51 16.58-24.51 16.58Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#racist-teacher-a)',
        }}
      >
        <path
          d="M1520.85 369.79s5.41 29.91 1.8 43.24c-3.6 13.33-10.45 45.41-11.53 64.51-1.08 19.1-7.21 64.87-6.13 75.68 1.08 10.81 5.05 9.37 5.05 16.22s-.36 13.69-.36 13.69h6.13v-14.41c0-6.85-3.24-7.57-4.68-15.86-1.44-8.29 3.6-64.87 5.77-77.12 2.16-12.25 7.21-47.93 10.81-62.7 3.6-14.78-2.88-44.69-2.88-44.69l-3.96 1.44Z"
          style={{
            fill: '#006ab3',
          }}
        />
      </g>
      <path
        d="M1599.05 495.56s8.65 5.41 11.17 12.97c2.52 7.57 2.16 12.97 2.16 12.97s-16.58 6.49-19.46 9.37-11.89 9.73-16.22 11.89c-4.32 2.16-12.61-37.84.72-41.08 13.33-3.24 21.62-6.13 21.62-6.13Z"
        style={{
          fill: '#e3b67d',
        }}
      />
      <path
        d="M1650.23 343.84c-7.56-.5-40.72 46.13-34.24 63.06 6.49 16.94 32.07 77.84 51.53 74.96 19.46-2.88 32.07-8.65 29.19-25.23-2.88-16.58-35.68-112.07-46.49-112.8Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1592.57 495.92s16.1-9.19 20.06-14.23c3.96-5.05 32.55-25.77 50.93-38.38 18.38-12.61 37.48 8.29 33.15 23.42-4.32 15.14-52.11 49.38-60.04 53.34-7.93 3.96-18.96 4.16-18.96 4.16l-9.65 3.4s.36-10.45-3.6-17.66c-3.96-7.21-11.89-14.05-11.89-14.05Zm-129.01-139.1c-11.91 6.77-9.73 41.08-12.97 63.79-3.24 22.7-21.88 65.43-22.96 75.88-1.08 10.45 13.35 30.57 18.04 32.38 4.68 1.8 31.91 5.55 31.91 5.55l18.05-133.27s-11.17-56.22-32.07-44.33Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1527.09 199.67c10.81-1.75 22.72.5 29.67 8.95s9.51 19.15 9.56 29.64c.05 10.49-.53 26.59-.53 26.59l-71.6 9.74s-2.83-10.66-5.46-17.76-1.96-14.37-1.93-24.32 2.05-17.41 10.3-23.78 29.98-9.05 29.98-9.05Z"
        style={{
          fill: '#e17136',
        }}
      />
      <path
        d="M1519.85 229.66c11.27-.86 25.41-8.15 28.32-3.02 2.91 5.13 4.69 16.21 4.69 16.21s7.32-1 7.12 5.66c-.2 6.66 2.2 12.13 2.2 12.13s1.47-5.45 6.77-5.06 4.44 8.24 3.11 14.77c-1.32 6.53-2.73 14.46-5.44 14.83s-6.26-1.36-6.26-1.36-1.79 13.23-5.05 19.75-13.21 12.57-19.02 14.47c-5.82 1.9-18.82 1.73-23.1-1.28-4.28-3.01-11.73-11.11-13.91-14.96-2.18-3.85-3.02-12.02-3.02-12.02s-2.54 3.66-5.68-1.16c-3.14-4.82-8.19-25.68-4.28-25.38 3.91.3 5.65.89 5.65.89s-1.88-7.75-1.24-11.16c.64-3.4 3.07-7.88 4.2-13.83s1.9-12.41 6.55-12.77c4.65-.36 13.76 3.65 18.4 3.3Z"
        style={{
          fill: '#e3b67d',
        }}
      />
      <path
        d="M1538.35 293.99c-.03 1.16-1.96 3.27-4.78 4.55-2.03.92-4.41 2.73-9.23 2.76-4.82.02-6.23-2.25-8.22-3.08-1.55-.64-3.52-2.67-2.94-3.95.52-1.15 5.4-3.15 7.38-3.11 1.98.05 3.29 1.45 4.31 1.39 1.02-.06 2.24-1.35 3.54-1.6s2.03.07 5.12.7c1.42.29 4.9-.37 4.82 2.35Z"
        style={{
          fill: '#d88b46',
        }}
      />
      <path
        d="M1513.04 246.97s-4.8 1.44-8.23 1.3c-3.44-.14-7.11.65-8.42 1.69s-2.84 5.03-2.84 5.03l1.04 1.14s2.65-3.11 3.65-3.33c2.18-.48 5.83.11 9.5-.31s6.59-.88 6.59-.88l-1.28-4.63Zm12.89 2.64-.02-5.61s4.09 3.02 8.66 2.22 7.72-1.34 9.74-.27c2.02 1.06 4.9 5.99 4.9 5.99l-1.58 1.43s-1.72-4.36-5.62-3.74-4.88 1.22-8.64 1.15c-4.13-.08-7.44-1.16-7.44-1.16Z"
        style={{
          fill: '#e17136',
        }}
      />
      <path
        d="M1535.01 256.08c-2.23.44-3.5 2.25-2.99 4.42.51 2.17 2.11 2.78 4.13 2.52 2.39-.31 3.46-2.01 3.16-4.29-.21-1.61-2-3.09-4.3-2.64Z"
        style={{
          fill: '#204a68',
        }}
      />
      <path
        style={{
          fill: '#204a68',
        }}
        d="m1531.5 258.5 11.17-.15.2-4.05-11.72 1.38.35 2.82zm-25.5-.02c2.08-.92 4.16-.18 4.99 1.9.83 2.07-.12 3.49-1.93 4.43-2.14 1.12-3.99.35-5.06-1.69-.75-1.44-.14-3.68 2-4.63Z"
      />
      <path
        style={{
          fill: '#204a68',
        }}
        d="m1510.86 259.77-10.14 3.29-1.98-3.55 11.46-3.05.66 3.31z"
      />
      <path
        d="M1516.01 193.63c13.1-1.45 25.43.97 31.11 3.88 5.68 2.92 15.23 15.33 18.43 26.93 3.2 11.61 3.02 20.96 3.02 20.96l-2.65.36s-19.03-13.39-49.94-9.81c-20.18 2.34-28.58 12.23-28.58 12.23l-4.47 1.88s-.97-10.71-1.28-20.19c-.31-9.48.16-16.73 6.87-21.84 6.71-5.11 22.57-13.87 27.48-14.42Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="m1515.31 206.5.42 9.82s-5.13.43-7.92.76-6.92 1.99-6.92 1.99l-.86-9.48s3.72-1.45 6.92-1.99c3.24-.55 8.37-1.09 8.37-1.09Z"
        style={{
          fill: '#e2007a',
        }}
      />
      <path
        d="M1563.28 241.81s-.43 10.34-12.75 9.36c-13.16-1.04-24.83-10.83-44.7-7.83-14.29 2.16-18.2 6.97-22.23 10.98-3.92 3.9-9.5 10.87-11.85 8.66-1.67-1.57 5.91-9.32 9.74-13.02 3.8-3.67 14.89-13.84 32.62-16.19 26.33-3.49 49.17 8.03 49.17 8.03Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1453.11 498.44c-8.29 2.07-6.85 19.46-6.13 23.42.72 3.96 7.57 4.32 9.73 5.77s4.5 4.23 4.5 4.23-3.06-7.47-1.26-15.4c1.8-7.93 6.85-16.22 6.85-16.22s-5.05 1.8-7.57 0c-2.52-1.8-3.24-2.52-6.13-1.8Z"
        style={{
          fill: '#e3b67d',
        }}
      />
      <path
        d="M1519.32 303.88c-1.33 8.09 6.85 16.9 6.85 16.9l6.65-.64s-.4-5.08.73-10.33c.85-3.92-.79-7.53-.79-7.53l-13.44 1.6Z"
        style={{
          fill: '#e17136',
        }}
      />
    </svg>
  )
}

export default RacistTeacherEnd
